import {
  buildTagDictionary,
  getTagNameFromEmail as getTagNameFromEmailShared,
  type ShipstationTagLike,
  type TagDictionary,
} from '@/shared/utils/shipstationTags';

export type { TagDictionary };

/** Build the bidirectional tag dictionary. Alias kept for existing component imports. */
export const tagDictionaryMaker = (allTags: ShipstationTagLike[]): TagDictionary =>
  buildTagDictionary(allTags);

export const getTagNameFromEmail = (
  email: string,
  tagDictionary: TagDictionary,
): string | null => getTagNameFromEmailShared(email, tagDictionary);
